/* =====================================================================
   Wise — accueil : « Les maisons » (wh-brands) et « Esprit tranquille » (wh-trust)
   Agent Confiance. Chargé en defer après wh-core.js (window.WH). ES2017 max, sans module.

   wh-brands : deuxième photo au survol. Chaque tuile garde l'image d'une autre pièce de la
   maison dans un <template> (inerte : rien n'est téléchargé). Sur les écrans à souris
   seulement, quand la section approche de l'écran, l'image est insérée dans la tuile ;
   la classe .has-alt, posée une fois l'image chargée, active le fondu au survol (wh-loyal.css).
   Le défileur mobile et la grille ordinateur sont gérés par le socle (WH.scroller + CSS).
   wh-trust : aucun script nécessaire (liens et bouton WhatsApp en HTML).
   ===================================================================== */
(function () {
  'use strict';

  var WH = window.WH;
  if (!WH) return;

  var pointerQuery = window.matchMedia ? window.matchMedia('(hover: hover) and (pointer: fine)') : null;

  function canHover() {
    return !!(pointerQuery && pointerQuery.matches);
  }

  /* Insère les deuxièmes photos d'une section, une seule fois (le template est remplacé). */
  function insertAlts(section) {
    WH.all('template[data-wh-brand-alt]', section).forEach(function (tpl) {
      var media = tpl.parentNode;
      if (!media || !tpl.content) return;
      var frag = document.importNode(tpl.content, true);
      var img = frag.querySelector('img');
      if (!img) {
        media.removeChild(tpl);
        return;
      }
      var tile = typeof media.closest === 'function' ? media.closest('.wh-brand__tile') : null;
      var done = false;
      var ready = function () {
        if (done) return;
        done = true;
        if (tile) tile.classList.add('has-alt');
      };
      img.decoding = 'async';
      img.addEventListener('load', ready);
      media.replaceChild(frag, tpl);
      if (img.complete && img.naturalWidth > 0) ready();
    });
  }

  function init(scope) {
    if (!canHover()) return;
    WH.all('[data-wh-brand-swap]', scope).forEach(function (section) {
      if (section.__whBrandStop) return;
      section.__whBrandStop = WH.inView(section, function () {
        insertAlts(section);
      }, null, { once: true, threshold: 0, rootMargin: '400px 0px' });
    });
  }

  WH.ready(init);

  WH.unload(function (section) {
    WH.all('[data-wh-brand-swap]', section).forEach(function (el) {
      if (typeof el.__whBrandStop === 'function') el.__whBrandStop();
      el.__whBrandStop = null;
    });
  });

  /* Souris branchée après le chargement (tablette hybride) : le survol s'active à ce moment-là. */
  if (pointerQuery) {
    var onPointerChange = function (e) {
      if (e.matches) init(document);
    };
    if (typeof pointerQuery.addEventListener === 'function') pointerQuery.addEventListener('change', onPointerChange);
    else if (typeof pointerQuery.addListener === 'function') pointerQuery.addListener(onPointerChange);
  }
})();
